import React, { Component } from 'react';

import { InsightPriority } from 'common/constants/insights';
import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveInsightBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve insight</div>
          <div className="text">
            Retrieves the details of an existing insight. You must specify the insight's unique
            identifier from Canny.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The insight's unique identifier from Canny.",
                heading: 'id',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns an insight object, if a valid identifier was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/insights/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/insights/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba1235`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1235",
  "author": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "company": {
    "monthlySpend": 1000,
    "name": "Company Name",
    "id": "1234567890",
    "urlName": "company-name"
  },
  "created": "${this.createdAt.toISOString()}",
  "priority": "${InsightPriority.high}",
  "source": {
    "name": "ui",
    "type": "manual"
  },
  "url": "https://example.com/insight",
  "users": [{
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  }],
  "value": "This is an important insight about the feature."
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
